import React from 'react';

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00002 6.66667L2.66669 8L6.66669 12L13.3334 5.33333L12 4L6.66669 9.33333L4.00002 6.66667Z"
        fill="#17385D"
      />
    </svg>
  );
}

export default CheckIcon;
